export const Hints = [
    "You can navigate media using the arrow keys!",
    "For a mobile app like experience add xquicky to your home screen!",
    "Tap on the left or right side of galleries for traversing",
    "Traverse video duration by simply tapping on the left or right hand side of your screen to bounce back and forth!",
    "Tap on images to zoom in, pan, and and simply swipe up or down to exit!"
]